import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "../lib/utils"
import '../components/inline-feedback.css';
import { PageNotice } from '../components/PageFeedback';

const alertVariants = cva(
  "relative w-full rounded-lg border px-4 py-3 text-sm [&>:is(svg,.wt-asset-icon,.wt-control-mark)+div]:translate-y-[-3px] [&>:is(svg,.wt-asset-icon,.wt-control-mark)]:absolute [&>:is(svg,.wt-asset-icon,.wt-control-mark)]:left-4 [&>:is(svg,.wt-asset-icon,.wt-control-mark)]:top-4 [&>:is(svg,.wt-asset-icon,.wt-control-mark)]:text-foreground [&>:is(svg,.wt-asset-icon,.wt-control-mark)~*]:pl-7",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        info: "bg-background text-foreground",
        success: "border-[var(--success-border)] bg-[var(--success-soft)] text-[var(--success-text)]",
        destructive:
          "border-destructive/50 text-destructive dark:border-destructive [&>:is(svg,.wt-asset-icon,.wt-control-mark)]:text-destructive",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const Alert = React.forwardRef(({ className, variant, ...props }, ref) => {
  const isError = !variant || ['default', 'destructive', 'error', 'warning'].includes(variant);
  const Component = isError ? PageNotice : 'div';
  return <Component
    ref={ref}
    role={variant === 'success' || variant === 'info' ? 'status' : 'alert'}
    className={cn(isError ? 'wt-inline-error' : alertVariants({ variant }), className)}
    {...props} />
})
Alert.displayName = "Alert"

const AlertTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h5
    ref={ref}
    className={cn("mb-1 font-medium leading-none tracking-tight", className)}
    {...props} />
))
AlertTitle.displayName = "AlertTitle"

const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("text-sm [&_p]:leading-relaxed", className)}
    {...props} />
))
AlertDescription.displayName = "AlertDescription"

export { Alert, AlertTitle, AlertDescription }
